import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Collapse } from 'wanderu-animations';
import {
    BigChevronUp,
    BigChevronDown,
} from 'wanderu-icons';

import CaretIcon from '../CaretIcon/CaretIcon';

import styles from './MobileAccordion.scss';

export default class MobileAccordion extends Component {
    static propTypes = {
        containerClass: PropTypes.string,
        contentClass: PropTypes.string,
        headerClass: PropTypes.string,
        iconClass: PropTypes.string,
        isHiddenAfterScroll: PropTypes.bool,
        isOpen: PropTypes.bool,
        title: PropTypes.string.isRequired,
        showChevron: PropTypes.bool,
    };

    static defaultProps = {
        containerClass: '',
        contentClass: '',
        headerClass: '',
        iconClass: '',
        isHiddenAfterScroll: false,
        isOpen: true,
        showChevron: false,
        onToggle() {},
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: this.props.isOpen,
        };
    }

    componentDidMount() {
        if (this.props.isHiddenAfterScroll) {
            window.addEventListener('scroll', this._autoCollapse);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this._autoCollapse);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { isOpen } = nextProps;

        if (isOpen !== this.props.isOpen) {
            this.setState(() => ({ isOpen }));
        }
    }

    _autoCollapse = () => {
        if (this.state.isOpen) {
            this.setState(() => ({ isOpen: false }));
        }

        window.removeEventListener('scroll', this._autoCollapse);
    };

    _toggleAccordionState = () => {
        this.setState(
            (oldState) => ({
                isOpen: !oldState.isOpen,
            }),
            this.props.onToggle(this.state.isOpen),
        );
    };

    render() {
        const {
            iconClass,
            id,
            title,
            headerClass,
            containerClass,
            contentClass,
            children,
            showChevron,
            collapseClassname,
        } = this.props;
        const {
            isOpen,
        } = this.state;

        return (
            <div
                aria-labelledby={id}
                className={classNames(containerClass)}
            >
                <span
                    aria-label={title}
                    aria-pressed={isOpen}
                    className={classNames(
                        styles.accordionHeader,
                        headerClass,
                    )}
                    id={id}
                    onClick={this._toggleAccordionState}
                    role="button"
                >
                    <h2 className={styles.title}>
                        {title}
                    </h2>
                    <span
                        className={classNames(
                            styles.icon,
                            { [iconClass]: !!iconClass },
                        )}
                    >
                        {!showChevron && (
                            <CaretIcon showUpArrow={isOpen} />
                        )}
                        {isOpen
                            ? (showChevron && <BigChevronUp />)
                            : (showChevron && <BigChevronDown />)}
                    </span>
                </span>
                <Collapse
                    className={collapseClassname}
                    duration={300}
                    isOpen={isOpen}
                >
                    <div className={contentClass}>
                        {children}
                    </div>
                </Collapse>
            </div>
        );
    }
}
